import { Component, OnInit, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { StarbaseSearchComponent, IStarbaseModularSearchField, TruncateString, TrackByUID } from 'starbase-launcher';
import { QMManual } from '../models/qmmanual';
import { Observable, of, Subscription } from 'rxjs';
import { LookupDataService } from '../services/lookup-data.service';

class ExtendedModularSearchField<T> implements IStarbaseModularSearchField<T> {
  /** Property name to use on the entity `T` */
  entityProps?: string[];
  fieldName: string;
  displayName?: string;
  default: boolean;
  enabled: boolean;
  filterClause: (value: T, search: string) => boolean;
}

@Component({
  selector: 'app-qm-search',
  templateUrl: './qm-search.component.html',
  styleUrls: ['./qm-search.component.css']
})
export class QmSearchComponent extends StarbaseSearchComponent<QMManual> implements OnInit, AfterViewInit, OnDestroy {
  @Input() placeholderText = 'Search QM Specifications...';
  @Input() searchText = '';

  protected modularSearchFields: ExtendedModularSearchField<QMManual>[] = [
    {
      displayName: 'Item Name',
      fieldName: 'ItemName',
      entityProps: ['ItemName'],
      default: true,
      enabled: true,
      filterClause: (q: QMManual, searchChars: string) => q && q.itemName && q.itemName.toLowerCase().includes(searchChars)
    },
    {
      displayName: 'Specification Text',
      fieldName: 'Specifications',
      entityProps: ['Specifications'],
      default: false,
      enabled: false,
      filterClause: (q: QMManual, searchChars: string) => q && q.specifications && q.specifications.toLowerCase().includes(searchChars)
    }
  ];
  get fieldsEnabledCount(): number { return this.enabledModularFilters().length; }

  private allQMArray$: Observable<QMManual[]>;
  private qmsSubscription: Subscription;

  hadText = this.getParentHadText;

  trackByUID = TrackByUID;

  constructor(private lookupSvc: LookupDataService) {
    super();
   }

  ngOnInit() {
    this.allQMArray$ = this.lookupSvc.getAllQMManuals();
    this.qmsSubscription = this.allQMArray$.subscribe(d => this.data = d.map(_ => _ = new QMManual().deserialize(_)));
    super.ngOnInit();
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    this.qmsSubscription.unsubscribe();
    super.ngOnDestroy();
  }

  outputModel(c: QMManual) {
    super.outputModel(c);
    this.clearEvent();
    this.triggerFocus();
  }

  protected runSearch(searchChars: string): Observable<QMManual[]> {
    console.log('Searching Quartermaster Specifications for ' + searchChars);
    const filters = this.enabledModularFilters();
    try {
      if (searchChars === '') {
        this.hadText = false;
        return of(this.data);
      }
      return of(this.data.filter(v => filters.some(f => f.filterClause(v, searchChars))));
    } catch (e) {
      console.error(e);
      this.errorOutput.emit();
      return of([]);
    }
  }

  public setTextToDisplay(m: QMManual): string {
    if (!m) { return; }
    return TruncateString(m.itemName, 30);
  }

  /*public clearEvent() {
    this.hadText = false;
    return of(this.data);
  }*/

  public configureSearch(): void {
    super.configureSearch();
  }

}
